import { useTenantCurrency } from '@kit/ui/currency-icon';
import { useTenantTimezone } from '@kit/ui/tenant-timezone-provider';

import { isArabicOffered } from './tenant-offered-locales';

/** Reads the tenant currency/timezone providers — no extra data loading. */
export function useIsArabicOffered() {
  return isArabicOffered(useTenantCurrency(), useTenantTimezone());
}

/**
 * Filters `locales` down to what the active tenant offers. The current
 * language is always kept so someone already viewing Arabic can switch back.
 */
export function useTenantOfferedLocales(
  locales: string[],
  currentLanguage: string,
) {
  const arabicOffered = useIsArabicOffered();

  if (arabicOffered) {
    return locales;
  }

  return locales.filter(
    (locale) => locale !== 'ar' || locale === currentLanguage,
  );
}
